<template>
  <div class="g_panel setting" :class="{ 'darkmode': darkMode }" >
    <!-- header -->
    <div class="header g_panel-header">
      <span class="back icon-back" role="button" aria-label="back" tabindex="0" @click.stop="backHandler" />
      <h1 class="title">
        <img :src="require('@/assets/about/logo_s@2x.png')" alt="icon" class="taglogo">
        Setting
      </h1>
    </div>
    <!-- end header -->
    <div class="setting-con g_scroll" >
      <!-- <div class="filed">
        <div class="label">{{$t('settingPanel.panelSize')}}</div>
        <div class="radio-w" @click="setSizeMode('1')" :class="{'radio-w_active': bigMode === true}">
          <div class="radio"></div>
          {{$t('settingPanel.panelSizeBig')}}
        </div>
        <div class="radio-w"  @click="setSizeMode('0')" :class="{'radio-w_active': bigMode === false}">
          <div class="radio"></div>
          {{$t('settingPanel.panelSizeSmall')}}
        </div>
      </div> -->
      <div class="filed filed-token">
        <div class="label">Access Token</div>
        <input @keydown.enter="setToken" @blur="setToken" class="filed-ipnput" :value="accessToken" :placeholder="$t('settingPanel.accessTokenInput')" type="text">
        <div class="tip">{{$t('settingPanel.tokenTip')}} <a target="_blank" href="https://github.com/alianrock/LittleStar/wiki/Access-token" class="link">{{$t('settingPanel.tokenLink')}}</a></div>
      </div>
      <div class="filed">
        <div class="label">{{$t('settingPanel.theme')}}</div>
        <div class="radio-w"  @click="setDarkMode('0')" :class="{'radio-w_active': darkMode === false}">
          <div class="radio"></div>
          {{$t('settingPanel.themeWhite')}}
        </div>
        <div class="radio-w"  @click="setDarkMode('1')" :class="{'radio-w_active': darkMode === true}">
          <div class="radio"></div>
          {{$t('settingPanel.themeDark')}}
        </div>
      </div>
      <div class="filed">
        <div class="label">{{$t('settingPanel.language')}}</div>
        <select class="select" @change="switchLanguage" :value="language" name="" id="">
          <option value="en">{{$t('settingPanel.langEn')}}</option>
          <option value="zh">{{$t('settingPanel.langCn')}}</option>
        </select>
      </div>
      <div class="filed filed_email">
        <div class="label">{{$t('settingPanel.email')}}</div>
        <btn class="btn"  @click.native="changeEmail" :label="$t('settingPanel.emailBtn')"></btn>
      </div>
      <div class="filed">
        <div class="label">{{$t('settingPanel.autoBackUp')}}</div>
        <div class="switchw">
          <div class="switch" @click="changeSetting('autoBackup', !user.autoBackup)">
            <div class="inner" :class="{'inner_close':user && !user.autoBackup }">
              <div class="inner-radio"></div>
            </div>
          </div>
          <div class="tip">{{$t('settingPanel.backTip')}}</div>
        </div>
        <btn class="btn" :loading="backUpIng" @click.native="backUpData" :label="$t('settingPanel.backUpBtn')"></btn>
      </div>
      <div class="filed filed_hotkey">
        <div class="label">{{$t('settingPanel.hotKeys')}}</div>
        <div class="hotkeylist">
          <div class="hotkey">
            <div class="name">Search star:</div>
            <div class="hotkey-value" :class="{'hotkey-value_active': editHotKey === 'searchStar'}" @click="(e) => starHotKeyEdit('searchStar', e)">{{editHotKey === 'searchStar' ? hotkeyEditVal : searchStarHotkey}}</div>
          </div>
          <div class="hotkey">
            <div class="name">Search tag:</div>
            <div class="hotkey-value" :class="{'hotkey-value_active': editHotKey === 'searchTag'}" @click="(e) => starHotKeyEdit('searchTag', e)">{{editHotKey === 'searchTag' ? hotkeyEditVal : searchTagHotkey}}</div>
          </div>
          <div class="hotkey">
            <div class="name">Edit star category:</div>
            <div class="hotkey-value" :class="{'hotkey-value_active': editHotKey === 'showEdit'}" @click="(e) => starHotKeyEdit('showEdit', e)">{{editHotKey === 'showEdit' ? hotkeyEditVal : showEditHotkey}}</div>
          </div>
          <div class="hotkey">
            <div class="name">Add tag:</div>
            <div class="hotkey-value" :class="{'hotkey-value_active': editHotKey === 'showAddBar'}" @click="(e) => starHotKeyEdit('showAddBar', e)">{{editHotKey === 'showAddBar' ? hotkeyEditVal : showAddBarHotkey}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { updateContentPage } from '@/util/chrome.api'
import btn from '@/components/Btn'
export default {
  components: {
    btn,
  },
  data() {
    return {
      backUpIng: false,
      show: false,
      language: 'en',
      editHotKey: '',
      hotkeyEditVal: '',
      hotKeyLoading: false,
    }
  },
  mounted() {
    this.language = (this.lang === 'en' || this.lang === 'zh' || this.lang === 'zh-CN') ? this.lang : 'en'
    if (this.language === 'zh-CN') this.language = 'zh'
    this.$on('show', () => { this.show = true })

    // 点击，记录编辑的键值
    // 点击，
    // 输入，获取键值，转换成+的形式，
    // blur，设置
    this.$hotkeys('*', (e) => {
      let key = ''
      if (this.$hotkeys.shift) {
        key += '⇧ '
      }

      if (this.$hotkeys.ctrl) {
        key += '⌃ '
      }

      if (this.$hotkeys.Capital) {
        key += '⇪ '
      }

      if (this.$hotkeys.alt) {
        key += '⌥ '
      }

      if (this.$hotkeys.option) {
        key += 'option '
      }

      if (this.$hotkeys.command) {
        key += '⌘ '
      }

      if (e.code === 'Space') {
        key += 'space '
      }
      if (e.key && (!key || e.key.indexOf(key) === -1) && e.key.toLowerCase() !== 'meta') {
        key += e.key.toLowerCase() + ' '
      }
      key = key.replace(/(^\s*)|(\s*$)/g, '')
      this.hotkeyEditVal = key.split(' ').join('+')
    })
  },
  beforeDestroy() {
    this.$hotkeys.unbind('*')
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      showAddBarHotkey: state => state.event.showAddBar,
      showEditHotkey: state => state.event.showEdit,
      searchStarHotkey: state => state.event.searchStar,
      searchTagHotkey: state => state.event.searchTag,
      user: state => state.user.user,
      accessToken: state => state.user.accessToken,
    }),
  },
  methods: {
    ...mapMutations({
      setSizeMode: 'setSizeMode',
      setDarkMode: 'setDarkMode',
      setAutoBackup: 'user/setAutoBackup',
      setAccessToken: 'user/setAccessToken',
      setOnEventPanel: 'event/setOnEventPanel',
    }),
    ...mapActions({
      setHotKey: 'event/setHotKey',
      switchLang: 'switchLang',
    }),
    setToken(e) {
      this.setAccessToken(e && e.target.value)
      this.$toast({
        msg: this.$t('settingPanel.tokenSetSucc'),
        confirm: true,
      })
      updateContentPage('reload')
    },
    starHotKeyEdit(key, e) {
      if (this.editHotKey && this.hotkeyEditVal !== this[key + 'Hotkey']) {
        this.setHotKey({ key: this.editHotKey, value: this.hotkeyEditVal })
      }
      if (this.editHotKey !== key) {
        this.editHotKey = key
        this.hotkeyEditVal = this[key + 'Hotkey']
        this.setOnEventPanel('hotKeyEdit')
        setTimeout(() => {
          document.addEventListener('click', this.endHotKeyEdit)
        }, 0)
      } else {
        this.setOnEventPanel('tagList')
        this.editHotKey = ''
        this.hotkeyEditVal = ''
        document.removeEventListener('click', this.endHotKeyEdit)
      }
    },
    endHotKeyEdit(e) {
      if (e.target.className.indexOf('hotkey-value') !== -1) return
      this.hotKeyLoading = true
      this.setHotKey({ key: this.editHotKey, value: this.hotkeyEditVal }).then(() => {
        this.editHotKey = ''
        this.hotkeyEditVal = ''
        this.setOnEventPanel('tagList')
      }).finally(() => {
        this.hotKeyLoading = true
      })
      document.removeEventListener('click', this.endHotKeyEdit)
    },
    changeHotKey(key) {
      this.setHotKey(key)
      this.editHotKey = this[key]
    },
    switchLanguage(e) {
      this.$locale = e.target.value
      this.language = e.target.value
      this.switchLang(e.target.value)
    },
    backHandler() {
      this.$router.back()
    },
    changeSetting(key, value) {
      this.$http.put('/setting/', {
        key,
        value,
      }).then(() => {
        this.setAutoBackup(value)
        this.$emit('startAnimate', 300)
      })
    },
    backUpData() {
      if (!this.user.email) {
        this.$toast({
          isConfirm: true,
          msg: this.$t('settingPanel.noEmailTip'),
        }).then(() => {
          this.$router.push({ name: 'email' })
        })
        return
      }
      this.backUpIng = true
      this.$emit('startAnimate')
      this.$http.get('/setting/backup').then(() => {
        this.$toast({
          msg: `${this.$t('settingPanel.sendEmailTip')} ${this.user.email} ${this.$t('settingPanel.sendEmailTip_2')}`,
        })
        this.$emit('startAnimate', 300)
        this.backUpIng = false
      }).catch(() => {
        this.backUpIng = false
      })
    },
    changeEmail() {
      this.$router.push({ name: 'email' })
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-con{
  padding: 20px 32px;
}
.filed{
  // display: flex;
  font-size: 14px;
  line-height:20px;
  margin-bottom: 18px;
  position: relative;
  .tip{
    display: inline-block;
    // position: absolute;
    // top: 23px;
    font-size: 12px;
    color: #686868;
    margin-left: 16px;
  }
}
.filed-token{
  align-items: center;
  .tip{
    top: 35px;
    font-size: 14px;
    padding-right: 10px;
  }
}

.link{
  color: #3582fb;
  &:hover{
    text-decoration: underline;
  }
}

.filed-ipnput{
  height: 32px;
  background: #FFFFFF;
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0 4px;
  width: 200px;
  color: #353535;
  font-size: 14px;
  &:focus{
    border-color: #3582fb;
  }
}
.label{
  font-size: 18px;
  line-height: 34px;
  border-bottom: 1px solid #E7E7E7;
  margin-right: 16px;
  margin-bottom: 10px;
}
.radio-w{
  cursor: pointer;
  display: flex;
  color: #646464;
  margin-right: 16px;
  height: 20px;
  line-height: 20px;
  align-items: center;
  margin-bottom: 8px;
}
.radio{
  background: #fff;
  margin-right: 4px;
  box-sizing: border-box;
  border: 1px solid #CACACA;
  border-radius: 999px;
  height: 13px;
  width: 13px;
}
.radio-w_active .radio{
  border: 4px solid #3582FB;
}
.switchw{
  display: flex;
}
.switch{
  display: flex;
  height: 18px;
  margin-top: 2px;
  margin-bottom: 16px;
  .inner{
    width: 36px;
    height: 16px;
    border-radius: 999px;
    border: 1px solid #3582FB;
    position: relative;
    background: #3582FB;
    overflow: hidden;
  }
  .inner-radio{
    border-radius: 999px;
    width:16px;
    height:16px;
    background:rgba(255,255,255,1);
    position: absolute;
    right: 0px;
    top: 0px;
    transition: all 0.2s ease;
  }
  .inner_close{
    border-color: #CACACA;
    .inner-radio{
      transform: translateX(-20px);
    }
    background: #CACACA;
  }
}
.setting .btn{
  height: 20px;
  border: 1px solid #3582FB;
  color: #3582FB;
  text-align: center;
  line-height: 20px;
  width:120px;
  padding: 0 8px;
  margin-left: 20px;
  font-size: 12px;
  border-radius: 999px;
  cursor: pointer;
  background: transparent;
  float: none;
  margin: 0;
  &:hover{
    background: rgba(55, 130, 251, 0.1);
  }
}
.setting .filed_email .btn{
  width: 120px;
  margin-left: 0px;
}
.setting .select{
  width: 100px;
  border: 1px solid #eee;
}
.hotkeylist{
  line-height: 26px;
  color: #444444;
  .hotkey{
    display: flex;
    margin-bottom: 16px;
  }
  .name{
    width: 130px;
  }
  .hotkey-value{
    margin-right: 20px;
    height: 26px;
    line-height: 26px;
    padding: 0 16px;
    border-radius: 8px;
    margin: 0 24px 0 8px;
    background: #eee;
    color: #646464;
    border: none;
    min-width: 150px;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid #e0e0e0;
  }
  .hotkey-value_active{
    border: 1px solid #3582fb;
  }
}
/* darkmode */
.darkmode{
  .label{
    color: #fff;
    border-bottom: 1px solid #424242;
  }
  .hotkeylist{
  line-height: 26px;
  color: #B1B1B1;
  }
  .hotkey-value{
    background: #545454;
    color: #B1B1B1;
  }
  .radio-w{
    color: #B1B1B1;
  }
  .filed .tip{
    color: #4b4b4b;
    margin-left: 8px;
    margin-top: 2px;
  }
}
</style>
